<template>

<div class="wardrobe-main l_wrap" style="padding-bottom: 0;">

  <div class="wardrobe-divided-title l_flipped-mobile">
    <p class="wardrobe-spec-title" v-if="item.valid && builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(item.total)"></p>
  </div>

  <div class="features s_open l_quote">
    <div class="features-body">
      <div class="features-body-inner l_flex" style="align-items: stretch;" :class="{ 'l_flex-wrap' : props.item.sections == 3 }">

        <template v-for="(section, index) in props.item.sections"
          v-bind:key="`${index}`">
          <button
            @click="lightboxActivate($event, props.item.data.sections[index].config)"
            :id="`kitchenSection${index}`"
            class="opt l_visual l_interiors l_trio l_frameless l_config l_overview"
            :class="{
              'height--auto width--70' : props.item.sections == 1,
              'height--auto width--50' : props.item.sections == 3,
            }">
            <div class="opt-inner">
              <div class="opt-tag">
                <svg class="icon" v-if="section.configId"><use href="#check"></use></svg>
                <span v-html="props.item.data.sections[index].title ?? builder.sectionTitles[index]"></span>
              </div>
              <div class="opt-image">
                <div class="opt-img" :style="`background-image: url(${props.item.data.sections[index].config.image});`"></div>
              </div>
              <div class="opt-footer">
                <div v-if="props.item.data.sections[index]">
                  <strong>{{ props.item.data.sections[index].config.title }}</strong>
                  <br />Wall Width: {{ props.item.data.sections[index].width }}mm
                  <br />Design Width: {{ props.item.data.sections[index].designWidth ?? props.item.data.sections[index].width }}mm
                </div>
                <div v-else>To be selected<br />&nbsp;</div>
              </div>
            </div>
          </button>
        </template>
        <!--  v-if="props.item.sections == 1" -->
        <!-- <template> -->
          <div
            class="opt l_visual l_interiors l_trio l_frameless l_config l_overview height--auto"
            :class="{
              'width--30' : props.item.sections == 1,
              'width--30' : props.item.sections == 2,
              'width--50' : props.item.sections == 3
            }">
            <div class="opt-inner">
              <div class="opt-tag">
                <span>Layout</span>
              </div>
              <div class="opt-image">
                <div class="opt-img" :style="`background-image: url(${props.item.data.layout.image});`" v-if="props.item.data.layout"></div>
                <div class="opt-img" v-else>
                  <Plan
                    :item="props.item"
                    :layout="props.item.productLayout.slug"
                    :wallspace="props.item.data.wallSpace.slug"
                    :sections="props.item.sections"
                    :interactive="false"></Plan>
                </div>
              </div>
              <div class="opt-footer">
                <div>
                  <strong>{{ props.item.product.title }}</strong><br />
                  {{ props.item.productLayout.title }}<br />
                  <span v-html="props.item.data.wallSpace.title" v-if="props.item.data.wallSpace"></span>
                </div>
              </div>
            </div>
          </div>
        <!-- </template> -->

      </div>
    </div>
  </div>

</div>

<div class="wardrobe-main l_specs">

  <div class="wardrobe-specs">

    <div class="wardrobe-spec l_w50">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Internal Hardware</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.hardware, 'hardware')" v-if="props.item.data.hardware">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.hardware.image});`" v-if="props.item.data.hardware"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.hardware.title" v-if="props.item.data.hardware"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.hardware">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
      <div class="wardrobe-spec-inner l_flush-top" v-if="props.item.data.drawerType && props.item.data.hasDrawers">
        <p class="wardrobe-spec-title">Drawer Type</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.drawerType, 'drawerType')" v-if="props.item.data.drawerType">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.drawerType.image});`" v-if="props.item.data.drawerType"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.drawerType.title" v-if="props.item.data.drawerType"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.drawerType">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>

    <div class="wardrobe-spec l_w50">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Internal Board Finish</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.board, 'board')" v-if="props.item.data.board">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.board.image});`" v-if="props.item.data.board"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.board.title" v-if="props.item.data.board"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.board">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>


    <template v-for="(section, index) in props.item.sections">

      <div class="wardrobe-specbreak"></div>

      <div class="wardrobe-spec l_w100" :class="{ 's_active' : showSectionSpecs(index) }">
        <button class="wardrobe-spec-inner" style="width: 100%; display: flex; align-items: center; justify-content: space-between;" @click="toggleSectionSpecs(index)">
          <strong v-if="props.item.data.sections[index].title" v-html="`${props.item.data.sections[index].title} Specifications`"></strong>
          <strong v-else>Section <span v-html="(index + 1)"></span> Specifications</strong>
          <svg class="icon l_flippable"><use href="#chevron-down"></use></svg>
        </button>
      </div>

      <div class="wardrobe-spec l_w60 l_toggle" :class="{ 's_active' : showSectionSpecs(index) }">
        <div class="wardrobe-spec-inner" style="padding-top: 0;">
          <p class="wardrobe-spec-title">Dimensions</p>
          <p class="wardrobe-spec-text">
            Width: <span class="l_light"><span v-html="props.item.specs.sections[index].width"></span>mm</span><br />
            Depth: <span class="l_light"><span v-html="props.item.data.depth.value"></span>mm</span>
          </p>
          <!-- <p class="wardrobe-spec-title">Components</p> -->
          <div class="wardrobe-spec-text l_light l_itemised" style="margin-bottom: 20px;" v-html="props.item.data.sections[index].config.description"></div>
        </div>
      </div>

      <div class="wardrobe-spec l_w40 l_toggle" :class="{ 's_active' : showSectionSpecs(index) }">
        <div class="wardrobe-spec-inner" style="padding-top: 0;">

          <button @click.stop="lightboxActivate($event, props.item.data.sections[index].config)" class="opt l_static l_combo s_active">
            <div class="opt-inner">
              <div class="opt-header">
                <div class="opt-title" v-html="props.item.data.sections[index].config.title"></div>
                <div class="opt-help">
                  <svg class="icon"><use xlink:href="#zoom"></use></svg>
                </div>
              </div>
              <div class="opt-image">
                <div class="opt-img" :style="`background-image: url(${props.item.data.sections[index].config.image});`"></div>
              </div>
            </div>
          </button>

        </div>
      </div>

    </template>


    <div class="wardrobe-specbreak" v-if="props.item.includedItemsList"></div>

    <div class="wardrobe-spec" v-if="props.item.includedItemsList">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Additional Items</p>
        <p class="wardrobe-spec-text l_light l_itemised">
          <!-- <span class="l_text-blue">Board materials in white melamine</span><br /> -->
          <span v-html="props.item.includedItemsList"></span>
        </p>
      </div>
    </div>


    <div class="wardrobe-specbreak" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid"></div>

    <div class="wardrobe-spec" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Custom Items</p>
        <p class="wardrobe-spec-text l_light">
          <span v-for="adjuster in props.item.adjusters">
            <span v-html="adjuster.title"></span>&nbsp;
            <span v-html="adjuster.totalCost"></span>
            <br />
          </span>
        </p>
      </div>
    </div>

  </div>

</div>

</template>

<script setup>

import { ref } from 'vue'

var _ = require('lodash');

const props = defineProps([
  'item'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['selectOption'])

const sectionSpecs = ref([]);

function toggleSectionSpecs(index) {
  if (typeof sectionSpecs.value[index] == undefined) sectionSpecs.value[index] = true;
  sectionSpecs.value[index] = !sectionSpecs.value[index];
  console.log(sectionSpecs.value);
}

function showSectionSpecs(index) {
  if (typeof sectionSpecs.value[index] !== undefined && sectionSpecs.value[index]) return true;
  return false;
}

function lightboxActivate(e, item, zoomType) {
  emit('lightboxActivate', item, zoomType);
  e.preventDefault();
  return false;
}
</script>
